import { createResourceCollection } from '@/request'
import { ResourceModel } from '@/request/types'
import { ThermostatComfortSetting } from '@/types'

export type InactiveComfortSetting = ResourceModel & {
  comfort_setting: ThermostatComfortSetting
  created?: string
  modified?: string
}

export const inactiveComfortSettingsCollection =
  createResourceCollection<InactiveComfortSetting>({
    name: 'inactiveComfortSettings',
    selector: (state) => state.inactiveComfortSettings,
  })

export default inactiveComfortSettingsCollection.slice.reducer
